import { ToastType } from '../components/Toast';

type ShowFn = (message: string, type?: ToastType, duration?: number) => void;

let _show: ShowFn | null = null;

export const globalToast = {
  register(fn: ShowFn) { _show = fn; },

  show(message: string, type: ToastType = 'info', duration?: number) {
    if (_show) _show(message, type, duration);
  },
  success(message: string) { this.show(message, 'success'); },
  error(message: string)   { this.show(message, 'error', 4000); },
  warning(message: string) { this.show(message, 'warning'); },
  info(message: string)    { this.show(message, 'info'); },
};
